//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
/** Services Import */
import Commons from '../../Services/Common/Common';
/** Components Import */
import meetingIcon from '../../Assets/Images/meetingIcon.svg';
import noticeIcon from '../../Assets/Images/noticeIcon.svg';
import { useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../Reducer/BottomSheetReducer';
import { NavBarInfoActions } from '../../Reducer/NavBarInfoReducer';
import { CommonActions } from '../../Reducer/CommonReducer';
import AlarmList from './AlarmList';
import {
  markAlarmAsReadInCache,
  removeAlarmFromCache,
} from '../../Hooks/useHasUnreadAlarm';
import { useDelete1, useSave1, useSearch1 } from './M_ALL_BASIC_Query';
import { useQueryClient } from '@tanstack/react-query';
import { useSave } from '../../Hooks/useSave';
import { M_ALL_BASIC_Schema } from './M_ALL_BASIC_Schema';
import { useDelete } from '../../Hooks/useDelete';
import { resetAlarmFlag } from '../../Reducer/InAppNotiReducer';
import { IsTraCustom02EduLogAlarmGubun } from '../../Presets/NotiPreset';
import { useSelector } from 'react-redux';
//#endregion

// #region 상수
const ChipItems = [
  { label: '전체' },
  { label: '안읽음' },
  { label: '작업' },
  { label: '공지사항' },
  { label: '회의록' },
  { label: '작업허가서' },
  { label: '교육일지' },
  // { label: '스케줄' },
];
const AlarIcon = {
  Meeting: meetingIcon,
  Notice: noticeIcon,
};
// #endregion
function AlarmListFunction() {
  //#region 변수
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { navigate } = useAppNavigate();
  const [originalAlarmList, setOriginalAlarmList] = useState([]); // 원본 알람LIST
  const [alarmList, setAlarmList] = useState([]); // 필터링된 알람LIST
  const [chipItems, setChipItems] = useState([]); // 알림 필터 상태
  const [chipIndex, setChipIndex] = useState(0); // 선택된 알림
  const [swipedIndex, setSwipedIndex] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [deletingAlarmCd, setDeletingAlarmCd] = useState(null); // 삭제 중인 알림 추적
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const { mutateAsync: save1Async } = useSave1();
  const { mutateAsync: Delete1Async } = useDelete1();
  //endregion

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('알림'));
    dispatch(NavBarInfoActions.setBgColor('#FFF'));
    dispatch(resetAlarmFlag());
    setChipItems(ChipItems);

    return () => {
      // 스택형 뒤로가기로 변경
      // 알림 화면은 legacy outlet-context backClick 정리 없이 공통 뒤로가기 흐름을 그대로 사용한다.
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: false,
          type: '',
        })
      );
    };
  }, []);

  //#region 조회
  //알림 조회()
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setAlarmList(Commons.InsertNumber(rows));
      setOriginalAlarmList(Commons.InsertNumber(rows));
    },
  });

  //#endregion
  //#region 저장
  const { run: Save1 } = useSave({
    menuId: 'AlarmList',
    schema: M_ALL_BASIC_Schema,
    requestSave: async (rows) => {
      const row = rows[0];

      await save1Async(row);
    },
  });

  //#endregion
  //#region 삭제
  const { run: Delete1 } = useDelete({
    menuId: 'M_NOT_BASIC_01',

    requestDelete: (rows) => Delete1Async(rows),

    onSuccess: ({ deleteDetailData, deletedRows }) => {
      const data = deleteDetailData;
      const _alarmCd = deletedRows[0]?.alarmCd;

      if (data && data.length > 0) {
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          setTimeout(() => {
            setAlarmList((prev) =>
              prev.filter((item) => item.alarmCd !== _alarmCd)
            );
            setOriginalAlarmList((prev) =>
              prev.filter((item) => item.alarmCd !== _alarmCd)
            );
            removeAlarmFromCache(queryClient, _alarmCd);
            setDeletingAlarmCd(null);
          }, 300);
        }
      }
    },
  });
  //#endregion
  //#region 나머지 함수
  // 페이지 이동이 없는 알림 클릭
  const AlarmCheck = (_value1) => {
    setAlarmList((prev) =>
      prev.map((item) =>
        item.alarmCd === _value1.alarmCd ? { ...item, useYn: 'Y' } : item
      )
    );
    setOriginalAlarmList((prev) =>
      prev.map((item) =>
        item.alarmCd === _value1.alarmCd ? { ...item, useYn: 'Y' } : item
      )
    );
    markAlarmAsReadInCache(queryClient, _value1.alarmCd);
    Save1({ alarmCd: _value1.alarmCd });
  };

  //알림창에서 확인 클릭(회의록일경우 _value1: 알람데이터)
  const MeetingAlarmCheck = (_value1) => {
    if (
      _value1.title === '산업안전보건위원회 회의록' ||
      _value1.title === '안전보건협의체 회의록'
    ) {
      navigate(_value1.route, {
        state: {
          data: _value1,
        },
      });
      AlarmCheck(_value1);
    } else if (_value1.title === '작업허가서') {
      dispatch(CommonActions.increaseStep());
      navigate(`/M_Permit/detail/${_value1.alarmData}`, {
        state: { from: '/M_AlarmList' },
      });
      AlarmCheck(_value1);
    } else if (_value1.title === '작업중지') {
      if (
        userInfo?.authCd === 'HEAD_MANAGER' ||
        userInfo?.authCd === 'BUSINESS_OWNER' ||
        userInfo?.approvalYn === 'Y'
      ) {
        dispatch(CommonActions.increaseStep());
        navigate(`/M_WorkStop/detail/${_value1.alarmData}`);
        AlarmCheck(_value1);
      } else {
        AlarmCheck(_value1);
      }
    } else if (
      IsTraCustom02EduLogAlarmGubun(_value1.alarmGubun) ||
      _value1.title === '교육일지 최종 결재 요청' ||
      _value1.title === '교육일지 결재 반려'
    ) {
      const tpmId = _value1.alarmData ?? _value1.responseData;
      if (tpmId) {
        dispatch(CommonActions.increaseStep());
        navigate(`/M_PendingApprovals/detail/${tpmId}`, {
          state: { from: '/M_AlarmList' },
        });
      }
      AlarmCheck(_value1);
    } else {
      // 기타 알림
      navigate(_value1.route);
      AlarmCheck(_value1);
    }
  };

  // 상단 버튼 클릭 이벤트
  const ChipClick = (index) => {
    setChipIndex(index);
    switch (index) {
      case 1:
        setAlarmList(originalAlarmList.filter((f) => f.useYn === 'N'));
        break;
      case 2:
        setAlarmList(
          originalAlarmList.filter((f) => f.alarmGubun?.startsWith('AL_004'))
        );
        break;
      case 3:
        setAlarmList(
          originalAlarmList.filter((f) => f.alarmGubun?.startsWith('AL_003'))
        );
        break;
      case 4:
        setAlarmList(
          originalAlarmList.filter((f) => f.alarmGubun?.startsWith('AL_001'))
        );
        break;
      case 5:
        setAlarmList(
          originalAlarmList.filter((f) => f.alarmGubun?.startsWith('AL_002'))
        );
        break;
      case 6:
        setAlarmList(
          originalAlarmList.filter((f) =>
            IsTraCustom02EduLogAlarmGubun(f.alarmGubun)
          )
        );
        break;
      default:
        setAlarmList(originalAlarmList);
        break;
    }
  };

  // n시간 전, n일 전 포맷
  const FormatDate = (createDate) => {
    const createdAt = new Date(createDate);
    const now = new Date();
    const diffInMs = now - createdAt; // 밀리초 단위 차이
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60)); // 시간 단위로 변환
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)); // 일 단위로 변환

    if (diffInDays > 0) {
      return `${diffInDays}일 전`;
    } else if (diffInHours > 0) {
      return `${diffInHours}시간 전`;
    } else {
      return '1시간 이내';
    }
  };

  // 최소 스와이프 거리
  const minSwipeDistance = 50;

  const SwipeTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const SwipeTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const SwipeTouchEnd = (index) => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setSwipedIndex(index);
    } else if (isRightSwipe) {
      setSwipedIndex(null);
    }
  };

  const HandleDeleteClick = (item) => {
    setDeletingAlarmCd(item.alarmCd);
    Delete1({ alarmCd: item.alarmCd });
    setSwipedIndex(null);
  };
  //#endregion
  return (
    <div className="wrap">
      <AlarmList
        AlarIcon={AlarIcon}
        alarmList={alarmList}
        chipItems={chipItems}
        chipIndex={chipIndex}
        // 함수
        AlarmCheck={AlarmCheck}
        MeetingAlarmCheck={MeetingAlarmCheck}
        ChipClick={ChipClick}
        FormatDate={FormatDate}
        // 스와이프 관련
        swipedIndex={swipedIndex}
        setSwipedIndex={setSwipedIndex}
        SwipeTouchStart={SwipeTouchStart}
        SwipeTouchMove={SwipeTouchMove}
        SwipeTouchEnd={SwipeTouchEnd}
        HandleDeleteClick={HandleDeleteClick}
        deletingAlarmCd={deletingAlarmCd}
      />
    </div>
  );
}

export default AlarmListFunction;
